export function shouldHideMobileMapSearch({
  useMobileTopChrome,
  isMapSearch,
  isCatchMarkerDetailsOpen,
}) {
  return Boolean(
    useMobileTopChrome && isMapSearch && isCatchMarkerDetailsOpen
  );
}
